import { ChangeDetectionStrategy, Component, input, signal } from "@angular/core";
import { ExposedAppEvent } from "@intocare-medapp/events/event.service.interface";

@Component({
	selector: "ic-app-event-item",
	templateUrl: "./sync-event-item.component.html",
	styleUrls: ["./sync-event-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AppEventItemComponent {
	appEvent = input.required<ExposedAppEvent>();

	protected showDetails = signal(false);
}
